import './App.scss';
import { Gear } from './components/Gear/Gear';

function App() {
  return (
    <div className='App'>
      <Gear />
    </div>
  );
}

export default App;
